module.exports = __webpack_public_path__ + "img/b0309_15.c4ad75ec.png";